import { gql } from '@apollo/client';

// NOTE: Inlined fields (no fragments) because the backend resolver uses
// extractFields/toMongoProjections which does not resolve fragment spreads —
// resulting in Mongo only returning _id and all other fields being null.

const PROVISIONING_TEMPLATE_FIELDS = `
  _id
  name
  createdAt
  lastUpdatedDate
  deviceNamePrefix
  deviceNameSuffix
  path
  tags
  wifiSsids
  ethernetNames
  currentType
  currentPlaylistId
  currentScheduleId
  currentAssetId
  stretchAsset
  documentDuration
  orientation
  tz
  syncPlay
  location {
    coordinates
    name
    place_id
  }
  actionIfPaired
  scale
  muted
`;

// --- Queries ---

export const PROVISIONING_TEMPLATES_QUERY = gql`
  query provisioningTemplates(
    $first: Int
    $after: String
    $query: QueryProvisioningTemplateInput
    $sort: ProvisioningTemplateSort
  ) {
    provisioningTemplates(first: $first, after: $after, query: $query, sort: $sort) {
      page {
        edges {
          cursor
          node {
            ${PROVISIONING_TEMPLATE_FIELDS}
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
      pageData {
        total
      }
    }
  }
`;

export const GET_PROVISIONING_TEMPLATE_DETAIL = gql`
  query getProvisioningTemplateDetail($_id: String!) {
    getProvisioningTemplateDetail(_id: $_id) {
      ${PROVISIONING_TEMPLATE_FIELDS}
    }
  }
`;

export const DOWNLOAD_PROVISIONING_TEMPLATE = gql`
  query downloadProvisioningTemplate($_id: String!, $type: ProvisioningTemplateDownloadType) {
    downloadProvisioningTemplate(_id: $_id, type: $type) {
      json
      fileName
    }
  }
`;

// --- Mutations ---

export const SAVE_PROVISIONING_TEMPLATE = gql`
  mutation saveProvisioningTemplate($input: ProvisioningTemplateInput!) {
    saveProvisioningTemplate(input: $input) {
      ${PROVISIONING_TEMPLATE_FIELDS}
    }
  }
`;

export const DELETE_PROVISIONING_TEMPLATE = gql`
  mutation deleteProvisioningTemplate($_id: String!) {
    deleteProvisioningTemplate(_id: $_id)
  }
`;
